import React, { FC } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx'

interface Props {
  open: boolean;
  card: string;
  onClick?: () => void;
}

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: "2.5em",
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.background.paper,
    width: theme.spacing(7),
    height: theme.spacing(10),
    borderStyle: 'solid',
    borderRadius: theme.spacing(1),
    borderWidth: 2,
    margin: `${theme.spacing(1)}px ${theme.spacing(2)}px`
  },
  closed: {
    borderColor: ' #4a235a ',
    backgroundColor: '#7d3c98',
    color: '#fff '
  },
  red: {
    borderColor: '#F00',
    color: '#F00'
  },
  black: {
    borderColor: '#000',
    color: '#000'
  },
  top: {
    marginBottom: theme.spacing(-1)
  },
  bottom: {
    marginTop: theme.spacing(-1)
  }
}));

/**
 * Card components
 *
 * @param props
 */
const CardComponent: FC<Props> = (props) => {
  const { open, card, onClick } = props;
  const classes = useStyles(props);

  const suit = card.slice(0, 1);
  const value = card.slice(1);

  let Icon = <>&#8466;</>;

  switch (suit) {
    case 'c':
      Icon = <>&clubs;</>;
      break;
    case 'd':
      Icon = <>&diams;</>;
      break;
    case 'h':
      Icon = <>&hearts;</>;
      break;
    case 's':
      Icon = <>&spades;</>;
      break;
    default:
      Icon = <>?</>;
  }

  const red = suit === 'h' || suit === 'd';

  return (
    <div
      className={clsx(classes.root, open && red && classes.red, open && !red && classes.black, !open && classes.closed)}
      onClick={onClick}
    >
      {
        open ?
          (
            <>
              <div className={classes.top}>{Icon}</div>
              <div className={classes.bottom}>{value}</div>
            </>
          ) : (
            <span>&#8466;</span>
          )
      }
    </div>
  )
}

export default CardComponent;
